import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import React, {useState} from "react";
import usePersistentStore from "../../../persistentStore";
import {makeStyles} from "@material-ui/core/styles";
import SearchBar from "material-ui-search-bar";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import AddIcon from '@material-ui/icons/Add';
import LabelOutlinedIcon from '@material-ui/icons/LabelOutlined';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined';
import {Tooltip} from "@material-ui/core";
import ConfirmationDialog from "../../../dialogs/confirmation";
import RefreshOutlinedIcon from '@material-ui/icons/RefreshOutlined';
import CircularProgress from "@material-ui/core/CircularProgress";
import InformationDialog from "../../../dialogs/information";
import ChangeTagsDialog from "../../../dialogs/changeTags";
import TuneOutlinedIcon from '@material-ui/icons/TuneOutlined';
import FilterDialog from "../../../dialogs/filters";
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import {Animated} from "react-animated-css";
import Button from "@material-ui/core/Button";
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import SelectContactListsDialog from "../../../dialogs/selectContactLists";
import PlaylistPlayOutlinedIcon from '@material-ui/icons/PlaylistPlayOutlined';
import PlaylistAddOutlinedIcon from '@material-ui/icons/PlaylistAddOutlined';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import MergeTypeOutlinedIcon from '@material-ui/icons/MergeTypeOutlined';
import ChooseExportFields from "../../../dialogs/chooseExportFields";
import MergeDialog from "../../../dialogs/merge";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    searchBar: {
        height: 32,
        '& .MuiIconButton-root': {
            padding: theme.spacing(1),
        }
    },
    toolbar: {
        '& .MuiIconButton-root': {
            padding: 4
        },
        '& .MuiToolbar-dense': {
            minHeight: 24,
        }
    }
}));

const PageBar = props => {
    const classes = useStyles();
    const [searchStr, setSearchStr] = useState('');
    const [informationOpen, setInformationOpen] = useState(false);
    const [informationTitle, setInformationTitle] = useState('');
    const [mergeOpen, setMergeOpen] = useState(false);
    const [mergeTitle, setMergeTitle] = useState('');
    const [informationText, setInformationText] = useState('');
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const [chooseExportFieldsOpen, setChooseExportFieldsOpen] = useState(false);
    const [confirmationTitle, setConfirmationTitle] = useState('');
    const [confirmationQuestion, setConfirmationQuestion] = useState('');
    const [confirmationYesHandler, setConfirmationYesHandler] = useState(null);
    const [addTagsOpen, setAddTagsOpen] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [globalPersistentState] = usePersistentStore();
    const [searchOpen, setSearchOpen] = useState(false);
    const [selectAddToContactListsOpen, setSelectAddToContactListsOpen] = useState(false);
    const [selectCopyToContactListsOpen, setSelectCopyToContactListsOpen] = useState(false);
    const [selectMoveToContactListsOpen, setSelectMoveToContactListsOpen] = useState(false);

    const handleInformationOK = () => {
        setInformationOpen(false);
    };

    const handleConfirmationYes = () => {
        confirmationYesHandler();
        setConfirmationOpen(false);
    };

    const handleConfirmationNo = () => {
        setConfirmationOpen(false);
    };

    const handleChooseExportFieldsExport = (selectedFields) => {
        props.handleExport(selectedFields);
        setChooseExportFieldsOpen(false);
    };

    const handleChooseExportFieldsCancel = () => {
        setChooseExportFieldsOpen(false);
    };

    const handleDeleteAfterConfirmation = () => {
        setConfirmationTitle("Delete Confirmation");
        setConfirmationQuestion("Are you sure you want to delete the selected record(s)?");
        setConfirmationYesHandler(() => () => props.handleDelete());
        setConfirmationOpen(true);
    };

    const handleRemoveFromContactListAfterConfirmation = () => {
        setConfirmationTitle("Remove from Contact List Confirmation");
        setConfirmationQuestion("Are you sure you want to remove the selected record(s) from this contact list?");
        setConfirmationYesHandler(() => () => {
            props.handleRemoveFromContactList();
        });
        setConfirmationOpen(true);
    };

    const handleAddTags = (tags) => {
        setAddTagsOpen(false);
        props.handleAddTags(tags);
    };

    const handleRemoveTags = (tags) => {
        setAddTagsOpen(false);
        props.handleRemoveTags(tags);
    };

    const handleCancelAddTags = () => {
        setAddTagsOpen(false);
    };

    const handleAddToContactLists = (contactLists) => {
        setSelectAddToContactListsOpen(false);
        props.handleAddToContactLists(contactLists);
    };

    const handleCancelAddToContactLists = () => {
        setSelectAddToContactListsOpen(false);
    };

    const handleFilterApply = (filterId) => {
        setFilterOpen(false);
        props.handleFilterApply(filterId);
    };

    const handleFilterCancel = () => {
        setFilterOpen(false);
    };

    const handleMerge = (choices) => {
        setMergeTitle(props.mergeTitle)
        setMergeOpen(false);
        props.handleMerge(choices);
    };

    const handleMergeCancel = () => {
        setMergeOpen(false);
    };

    const handleCopyToContactLists = (contactLists) => {
        setSelectCopyToContactListsOpen(false);
        props.handleCopyToContactLists(contactLists);
    };

    const handleCancelCopyToContactLists = () => {
        setSelectCopyToContactListsOpen(false);
    };

    const handleMoveToContactLists = (newContactLists) => {
        setSelectMoveToContactListsOpen(false);
        props.handleMoveToContactLists(props.currentContactLists, newContactLists);
    };

    const handleCancelMoveToContactLists = () => {
        setSelectMoveToContactListsOpen(false);
    };

    return (
        <div>
            {globalPersistentState.me && (
                <div>
                    <AppBar position="static" color={props.color ? props.color : 'default'} className={classes.toolbar}>
                        <Toolbar variant="dense" className={classes.toolbar}>
                            <Typography variant="subtitle1" color="inherit" m={2} style={{marginRight: 20}}>
                                {props.title}
                            </Typography>
                            {props.showLoading && <CircularProgress color="inherit" size={24}/>}
                            <div className={classes.grow}/>
                            {props.handleRefresh && (
                                <Tooltip title={"Refresh"}>
                                    <div>
                                        <IconButton
                                            id={"refresh-button"}
                                            aria-controls="refresh"
                                            color="inherit"
                                            aria-label="refresh"
                                            onClick={props.handleRefresh}
                                        >
                                            <RefreshOutlinedIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {searchOpen && props.handleSearch && (
                                <Animated animationIn="rotateInDownRight" animationOut="slideOutRight"
                                          isVisible={searchOpen}>
                                    <SearchBar
                                        className={classes.searchBar}
                                        aria-controls="search"
                                        color="primary"
                                        aria-label="search"
                                        onChange={(s) => setSearchStr(s)}
                                        onRequestSearch={() => {
                                            props.handleSearch(searchStr);
                                        }}
                                        onCancelSearch={() => setSearchStr('')}
                                        value={searchStr}
                                    />
                                </Animated>
                            )}
                            {props.handleSearch && (
                                <Tooltip title={"Open Search"}>
                                    <div>
                                        <IconButton
                                            id={"toggle-search-button"}
                                            aria-controls="toggle-search"
                                            color="inherit"
                                            aria-label="toggle-search"
                                            onClick={() => {
                                                setSearchOpen(!searchOpen);
                                            }}
                                        >
                                            <SearchOutlinedIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {props.handleFilterApply && (
                                <Tooltip title={"Filter"}>
                                    <div>
                                        {props.filterName && (
                                            <Button
                                                variant="outlined"
                                                color="default"
                                                size={"small"}
                                                className={classes.button}
                                                endIcon={<TuneOutlinedIcon/>}
                                                onClick={() => {
                                                    setFilterOpen(true);
                                                }}
                                            >
                                                {props.filterName}
                                            </Button>
                                        )}
                                        {!props.filterName && (
                                            <IconButton
                                                id={"filter-button"}
                                                aria-controls="filter"
                                                disabled={props.filterDisabled}
                                                color="inherit"
                                                aria-label="filter"
                                                onClick={() => {
                                                    setFilterOpen(true);
                                                }}
                                            >
                                                <TuneOutlinedIcon/>
                                            </IconButton>
                                        )}
                                    </div>
                                </Tooltip>
                            )}
                            {props.handleMerge && (
                                <Tooltip title={"Merge"}>
                                    <div>
                                        <IconButton
                                            id={"merge-button"}
                                            aria-controls="merge"
                                            disabled={props.mergeDisabled}
                                            color="inherit"
                                            aria-label="merge"
                                            onClick={() => {
                                                setMergeOpen(true);
                                            }}
                                        >
                                            <MergeTypeOutlinedIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {props.handleAdd && (
                                <Tooltip title={"Add"}>
                                    <div>
                                        <IconButton
                                            id={"add-button"}
                                            aria-controls="add"
                                            disabled={props.addDisabled}
                                            color="inherit"
                                            aria-label="add"
                                            onClick={props.handleAdd}
                                        >
                                            <AddIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {props.handleEdit && (
                                <Tooltip title={"Edit"}>
                                    <div>
                                        <IconButton
                                            id={"edit-button"}
                                            aria-controls="edit"
                                            disabled={props.editDisabled}
                                            color="inherit"
                                            aria-label="edit"
                                            onClick={props.handleEdit}
                                        >
                                            <EditOutlinedIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {props.handleAddTags && props.handleRemoveTags && (
                                <Tooltip title={"Tag"}>
                                    <div>
                                        <IconButton
                                            id={"tag-button"}
                                            aria-controls="tag"
                                            disabled={props.tagDisabled}
                                            color="inherit"
                                            aria-label="tag"
                                            onClick={() => {
                                                setAddTagsOpen(true);
                                            }}
                                        >
                                            <LabelOutlinedIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {props.handleAddToContactLists && (
                                <Tooltip title={"Add to contact lists"}>
                                    <div>
                                        <IconButton
                                            id={"add-to-lists-button"}
                                            aria-controls="add-to-lists"
                                            disabled={props.addToContactListsDisabled}
                                            color="inherit"
                                            aria-label="add-to-lists"
                                            onClick={() => {
                                                setSelectAddToContactListsOpen(true);
                                            }}
                                        >
                                            <PlaylistAddIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {props.handleImport && (
                                <Tooltip title={"Import"}>
                                    <div>
                                        <IconButton
                                            id={"import-button"}
                                            aria-controls="import"
                                            disabled={props.importDisabled}
                                            color="inherit"
                                            aria-label="import"
                                            onClick={() => {
                                                // props.handleImport
                                                setInformationTitle('Import Not Ready');
                                                setInformationText("Sorry... import is not implemented yet.");
                                                setInformationOpen(true);
                                            }}
                                        >
                                            <PublishOutlinedIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {props.handleExport && (
                                <Tooltip title={"Export"}>
                                    <div>
                                        <IconButton
                                            id={"export-button"}
                                            aria-controls="export"
                                            disabled={props.exportDisabled}
                                            color="inherit"
                                            aria-label="export"
                                            onClick={() => {
                                                setChooseExportFieldsOpen(true);
                                            }}
                                        >
                                            <GetAppOutlinedIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {props.handleDelete && (
                                <Tooltip title={"Delete"}>
                                    <div>
                                        <IconButton
                                            id={"delete-button"}
                                            aria-controls="delete"
                                            disabled={props.deleteDisabled}
                                            color="inherit"
                                            aria-label="delete"
                                            onClick={handleDeleteAfterConfirmation}
                                        >
                                            <DeleteOutlineOutlinedIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {props.handleCopyToContactLists && (
                                <Tooltip title={"Copy to another contact list"}>
                                    <div>
                                        <IconButton
                                            id={"copy-to-list-button"}
                                            aria-controls="copy-to-list"
                                            disabled={props.copyToContactListDisabled}
                                            color="inherit"
                                            aria-label="copy-to-list"
                                            onClick={() => {
                                                setSelectCopyToContactListsOpen(true);
                                            }}
                                        >
                                            <PlaylistAddOutlinedIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {props.handleMoveToContactLists && (
                                <Tooltip title={"Move to another contact list"}>
                                    <IconButton
                                        id={"move-to-list-button"}
                                        aria-controls="move-to-list"
                                        disabled={props.moveToContactListDisabled}
                                        color="inherit"
                                        aria-label="copy-to-list"
                                        onClick={() => {
                                            setSelectMoveToContactListsOpen(true);
                                        }}
                                    >
                                        <PlaylistPlayOutlinedIcon/>
                                    </IconButton>
                                </Tooltip>
                            )}
                            {props.handleRemoveFromContactList && (
                                <Tooltip title={"Remove from contact list"}>
                                    <div>
                                        <IconButton
                                            id={"remove-from-list-button"}
                                            aria-controls="remove-from-list"
                                            disabled={props.removeFromContactListDisabled}
                                            color="inherit"
                                            aria-label="remove-from-list"
                                            onClick={handleRemoveFromContactListAfterConfirmation}
                                        >
                                            <HighlightOffOutlinedIcon/>
                                        </IconButton>
                                    </div>
                                </Tooltip>
                            )}
                            {props.children}
                        </Toolbar>
                    </AppBar>
                </div>
            )}
            {addTagsOpen && <ChangeTagsDialog
                open={addTagsOpen}
                title={props.addTagsTitle}
                handleAddTags={handleAddTags}
                handleRemoveTags={handleRemoveTags}
                handleCancelAddTags={handleCancelAddTags}
            />}
            {chooseExportFieldsOpen && <ChooseExportFields
                {...props}
                open={chooseExportFieldsOpen}
                title={'Choose Fields to Export'}
                handleExport={handleChooseExportFieldsExport}
                handleCancel={handleChooseExportFieldsCancel}
            />}
            {confirmationOpen && <ConfirmationDialog
                open={confirmationOpen}
                title={confirmationTitle}
                question={confirmationQuestion}
                handleYes={handleConfirmationYes}
                handleNo={handleConfirmationNo}
            />}
            {filterOpen && <FilterDialog
                open={filterOpen}
                filterType={props.filterType}
                handleApply={handleFilterApply}
                handleCancel={handleFilterCancel}
            />}
            {informationOpen && <InformationDialog
                open={informationOpen}
                title={informationTitle}
                information={informationText}
                handleOK={handleInformationOK}
            />}
            {mergeOpen && <MergeDialog
                open={mergeOpen}
                title={mergeTitle}
                choices={props.mergeChoices}
                handleMerge={handleMerge}
                handleCancel={handleMergeCancel}
            />}
            {selectAddToContactListsOpen && <SelectContactListsDialog
                open={selectAddToContactListsOpen}
                title={"Select Contact Lists to Add To"}
                handleSelect={handleAddToContactLists}
                handleCancel={handleCancelAddToContactLists}
            />}
            {selectCopyToContactListsOpen && <SelectContactListsDialog
                open={selectCopyToContactListsOpen}
                title={"Select Contact Lists to Copy To"}
                handleSelect={handleCopyToContactLists}
                handleCancel={handleCancelCopyToContactLists}
            />}
            {selectMoveToContactListsOpen && <SelectContactListsDialog
                open={selectMoveToContactListsOpen}
                title={"Select Contact Lists to Move To"}
                handleSelect={handleMoveToContactLists}
                handleCancel={handleCancelMoveToContactLists}
            />}
        </div>
    );
};

export default PageBar;
